module.exports = __webpack_public_path__ + "img/49200.0cca0c68.jpg";